// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pJFG","footer":"styles_footer__k4F9j","passCodeTooltip":"styles_passCodeTooltip__wPhEY"};